export default {"src":"/_next/static/media/mascot-ecstatic.5d893c39.gif","height":200,"width":200,"blurWidth":0,"blurHeight":0};